export const REQUEST_SET_CHAIN_ADDRESS = 'REQUEST_SET_CHAIN_ADDRESS';
export const RECEIVE_SET_CHAIN_ADDRESS = 'RECEIVE_SET_CHAIN_ADDRESS';
export const ERROR_SET_CHAIN_ADDRESS = 'ERROR_SET_CHAIN_ADDRESS';
export const WAITING_SET_CHAIN_ADDRESS = 'WAITING_SET_CHAIN_ADDRESS';
export const CLOSE_SET_CHAIN_ADDRESS = 'CLOSE_SET_CHAIN_ADDRESS';

export const REQUEST_CHAIN_ADDRESS = 'REQUEST_CHAIN_ADDRESS';
export const RECEIVE_CHAIN_ADDRESS = 'RECEIVE_CHAIN_ADDRESS';
export const ERROR_CHAIN_ADDRESS = 'ERROR_CHAIN_ADDRESS';
export const CLEAR_ADDRESSES = 'CLEAR_ADDRESSES';

export const ADDRESS_ENCODING_ERROR = 'ADDRESS_ENCODING_ERROR';
